import React, { useState } from "react"
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  FormHelperText,
  TextField,
  Typography,
} from "@material-ui/core"
import * as Utils from "@utils"
import styled from "styled-components"
import * as IconsGallery from "@iconsGallery"
import { makeStyles } from "@material-ui/core/styles"
import { useStyles } from "@material-ui/pickers/views/Calendar/Day"
import Autocomplete from "@material-ui/lab/Autocomplete"
import _ from "lodash"
import { render } from "@testing-library/react"

const usestyles = makeStyles({
  paper: {
    border: "1px solid grey",
  },
})

function DropdownFilter(props) {
  let {
    list = [],
    defaultValue = "",
    selectedValue = "",
    onChangeEvent = () => {},
    popupOpen = false,
    onInputChangeEvent = () => {},
    setPopupOpen = () => {},
    disableClearable = true,
    classNameTextField = "",
    touchedControl = "",
    errorControl = "",
    placeholder = "",
    style = {},
    disabled = false,
    name = "",
    label = "",
    styleDropdownProps = {},
    className = "",
    onBlur = () => "",
    isInnerWrapperCheck = false,
  } = props

  let isDisabled = list?.length > 0 ? disabled : list?.length === 0
  const disabledAutocompleteStyle = isDisabled
    ? { backgroundColor: "#F9F9FC" }
    : {}

  const classes = usestyles()
  return (
    <>
      <Autocomplete
        name={name}
        className={className}
        ListboxProps={styleDropdownProps}
        options={list}
        value={
          list?.length > 0
            ? _.isEmpty(selectedValue)
              ? defaultValue
              : selectedValue
            : ""
        }
        classes={{ paper: classes.paper }}
        onChange={onChangeEvent}
        disabled={isDisabled}
        getOptionLabel={(option) =>
          _.isObject(option) ? option?.name : option
        }
        open={popupOpen}
        onInputChange={onInputChangeEvent}
        onOpen={() => {
          setPopupOpen(true)
        }}
        onClose={() => {
          setPopupOpen(false)
        }}
        onBlur={onBlur}
        disableClearable={disableClearable}
        style={style}
        renderInput={(params) => (
          <TextField
            {...params}
            name={name}
            label={label}
            variant="outlined"
            className={classNameTextField}
            style={{
              ...disabledAutocompleteStyle,
            }}
            placeholder={placeholder}
            error={Boolean(touchedControl && errorControl)}
            helperText={touchedControl && errorControl}
          />
        )}
      />
    </>
  )
}
export { DropdownFilter }
export default DropdownFilter
